import React from 'react';
import Loading from '../loading/loading';
import './collection.scss';

export default () => (
  <div className="collection-loading">
    <Loading />
  </div>
);
